type Theme = {
  accentBackground: string;
  accentColor: string;
  background0: string;
  background025: string;
  background05: string;
  background075: string;
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
  color6: string;
  color7: string;
  color8: string;
  color9: string;
  color10: string;
  color11: string;
  color12: string;
  color0: string;
  color025: string;
  color05: string;
  color075: string;
  background: string;
  backgroundHover: string;
  backgroundPress: string;
  backgroundFocus: string;
  borderColor: string;
  borderColorHover: string;
  borderColorPress: string;
  borderColorFocus: string;
  color: string;
  colorHover: string;
  colorPress: string;
  colorFocus: string;
  colorTransparent: string;
  placeholderColor: string;
  outlineColor: string;

}

function t(a: [number, number][]) {
  let res: Record<string,string> = {}
  for (const [ki, vi] of a) {
    res[ks[ki] as string] = vs[vi] as string
  }
  return res as Theme
}
const vs = [
  'hsla(186, 100%, 96.3%, 1)',
  'hsla(191, 91.4%, 36.5%, 1)',
  'hsla(36, 0%, 100%, 0)',
  'hsla(36, 0%, 100%, 0.25)',
  'hsla(36, 0%, 100%, 0.5)',
  'hsla(36, 0%, 100%, 0.75)',
  'hsla(36, 0%, 100%, 1)',
  'hsla(36, 10%, 97%, 1)',
  'hsla(36, 8%, 94%, 1)',
  'hsla(36, 8%, 90%, 1)',
  'hsla(36, 5%, 83%, 1)',
  'hsla(36, 5%, 70%, 1)',
  'hsla(36, 5%, 55%, 1)',
  'hsla(36, 5%, 40%, 1)',
  'hsla(36, 5%, 30%, 1)',
  'hsla(36, 5%, 20%, 1)',
  'hsla(36, 6%, 12%, 1)',
  'hsla(36, 8%, 4%, 1)',
  'hsla(36, 10%, 10%, 0)',
  'hsla(36, 10%, 10%, 0.25)',
  'hsla(36, 10%, 10%, 0.5)',
  'hsla(36, 10%, 10%, 0.75)',
  'hsla(194.6, 63.6%, 23.7%, 1)',
  'hsla(188.7, 94.5%, 42.7%, 1)',
  'hsla(36, 6%, 10%, 1)',
  'hsla(36, 5%, 15.9%, 1)',
  'hsla(36, 5%, 26.1%, 1)',
  'hsla(36, 5%, 33.9%, 1)',
  'hsla(36, 5%, 46.1%, 1)',
  'hsla(36, 5%, 64.9%, 1)',
  'hsla(36, 5%, 83.9%, 1)',
  'hsla(36, 8%, 95.9%, 1)',
  'hsla(36, 10%, 93%, 1)',
  'hsla(0, 0%, 100%, 1)',
  'hsla(0, 21.90%, 58.80%, 0.00)',
  'hsla(0, 0%, 100%, 0.25)',
  'hsla(0, 0%, 100%, 0.5)',
  'hsla(0, 0%, 100%, 0.75)',
  'hsla(0, 0%, 98%, 1)',
  'hsla(36, 5.2%, 33.9%, 1)',
  'hsla(191, 0%, 100%, 0)',
  'hsla(191, 0%, 100%, 0.25)',
  'hsla(191, 0%, 100%, 0.5)',
  'hsla(191, 0%, 100%, 0.75)',
  'hsla(191, 98%, 96.3%, 1)',
  'hsla(191, 95.9%, 75%, 1)',
  'hsla(191, 93.5%, 75%, 1)',
  'hsla(191, 92.4%, 69%, 1)',
  'hsla(191, 85.7%, 53.3%, 1)',
  'hsla(191, 94.5%, 42.7%, 1)',
  'hsla(191, 82.3%, 31%, 1)',
  'hsla(191, 69.6%, 27.1%, 1)',
  'hsla(191, 63.6%, 23.7%, 1)',
  'hsla(191, 79%, 15%, 1)',
  'hsla(191, 79%, 15%, 0)',
  'hsla(191, 79%, 15%, 0.25)',
  'hsla(191, 79%, 15%, 0.5)',
  'hsla(191, 79%, 15%, 0.75)',
  'hhsla(240, 4.8%, 95.9%, 1)',
  'hsla(191, 61%, 46%, 1)',
  'hsla(191, 50%, 35%, 0)',
  'hsla(191, 50%, 35%, 0.25)',
  'hsla(191, 50%, 35%, 0.5)',
  'hsla(191, 50%, 35%, 0.75)',
  'hsla(191, 69.6%, 27%, 1)',
  'hsla(191, 100%, 96.3%, 1)',
  'hsla(0, 0%, 100%, 0)',
  'rgba(0,0,0,0.5)',
  'rgba(0,0,0,0.8)',
]

const ks = [
'accentBackground',
'accentColor',
'background0',
'background025',
'background05',
'background075',
'color1',
'color2',
'color3',
'color4',
'color5',
'color6',
'color7',
'color8',
'color9',
'color10',
'color11',
'color12',
'color0',
'color025',
'color05',
'color075',
'background',
'backgroundHover',
'backgroundPress',
'backgroundFocus',
'borderColor',
'borderColorHover',
'borderColorPress',
'borderColorFocus',
'color',
'colorHover',
'colorPress',
'colorFocus',
'colorTransparent',
'placeholderColor',
'outlineColor']


const n1 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 14],[15, 15],[16, 16],[17, 17],[18, 18],[19, 19],[20, 20],[21, 21],[22, 7],[23, 6],[24, 7],[25, 7],[26, 9],[27, 9],[28, 10],[29, 9],[30, 17],[31, 16],[32, 21],[33, 21],[34, 18],[35, 11],[36, 19]])

export const light = n1
const n2 = t([[0, 22],[1, 23],[2, 18],[3, 19],[4, 20],[5, 21],[6, 17],[7, 24],[8, 25],[9, 26],[10, 27],[11, 28],[12, 29],[13, 30],[14, 9],[15, 31],[16, 32],[17, 33],[18, 34],[19, 35],[20, 36],[21, 37],[22, 17],[23, 17],[24, 24],[25, 24],[26, 26],[27, 26],[28, 27],[29, 26],[30, 33],[31, 32],[32, 37],[33, 37],[34, 34],[35, 28],[36, 35]])

export const dark = n2
const n3 = t([[0, 38],[1, 39],[2, 40],[3, 41],[4, 42],[5, 43],[6, 33],[7, 44],[8, 45],[9, 46],[10, 47],[11, 48],[12, 49],[13, 1],[14, 50],[15, 51],[16, 52],[17, 53],[18, 54],[19, 55],[20, 56],[21, 57],[22, 44],[23, 33],[24, 44],[25, 44],[26, 46],[27, 46],[28, 47],[29, 46],[30, 53],[31, 52],[32, 57],[33, 57],[34, 54],[35, 48],[36, 55]])

export const light_accent = n3
const n4 = t([[0, 58],[1, 59],[2, 60],[3, 61],[4, 62],[5, 63],[6, 53],[7, 52],[8, 64],[9, 50],[10, 1],[11, 49],[12, 48],[13, 47],[14, 46],[15, 45],[16, 65],[17, 33],[18, 66],[19, 35],[20, 36],[21, 37],[22, 53],[23, 53],[24, 52],[25, 52],[26, 50],[27, 50],[28, 1],[29, 50],[30, 33],[31, 65],[32, 37],[33, 37],[34, 66],[35, 49],[36, 35]])

export const dark_accent = n4
const n5 = t([[30, 16],[31, 15],[32, 16],[33, 15]])

export const light_alt1 = n5
const n6 = t([[30, 15],[31, 14],[32, 15],[33, 14]])

export const light_alt2 = n6
const n7 = t([[22, 9],[23, 8],[24, 10],[25, 10],[26, 12],[27, 11],[29, 12],[28, 13]])

export const light_active = n7
export const light_surface3 = n7
export const light_Button = n7
export const light_SliderTrackActive = n7
const n8 = t([[22, 7],[23, 6],[24, 8],[25, 8],[26, 10],[27, 9],[29, 10],[28, 11]])

export const light_surface1 = n8
export const light_ListItem = n8
export const light_SelectTrigger = n8
export const light_Card = n8
export const light_Progress = n8
export const light_TooltipArrow = n8
export const light_SliderTrack = n8
export const light_Input = n8
export const light_TextArea = n8
const n9 = t([[22, 8],[23, 7],[24, 9],[25, 9],[26, 11],[27, 10],[29, 11],[28, 12]])

export const light_surface2 = n9
export const light_Checkbox = n9
export const light_Switch = n9
export const light_TooltipContent = n9
export const light_RadioGroupItem = n9
const n10 = t([[22, 11],[23, 11],[24, 12],[25, 12],[26, 11],[27, 11],[29, 12],[28, 12]])

export const light_surface4 = n10
const n11 = t([[30, 32],[31, 31],[32, 32],[33, 31]])

export const dark_alt1 = n11
const n12 = t([[30, 31],[31, 9],[32, 31],[33, 9]])

export const dark_alt2 = n12
const n13 = t([[22, 26],[23, 27],[24, 25],[25, 25],[26, 29],[27, 30],[29, 29],[28, 28]])

export const dark_active = n13
export const dark_surface3 = n13
export const dark_Button = n13
export const dark_SliderTrackActive = n13
const n14 = t([[22, 24],[23, 25],[24, 17],[25, 17],[26, 27],[27, 28],[29, 27],[28, 26]])

export const dark_surface1 = n14
export const dark_ListItem = n14
export const dark_SelectTrigger = n14
export const dark_Card = n14
export const dark_Progress = n14
export const dark_TooltipArrow = n14
export const dark_SliderTrack = n14
export const dark_Input = n14
export const dark_TextArea = n14
const n15 = t([[22, 25],[23, 26],[24, 24],[25, 24],[26, 28],[27, 29],[29, 28],[28, 27]])

export const dark_surface2 = n15
export const dark_Checkbox = n15
export const dark_Switch = n15
export const dark_TooltipContent = n15
export const dark_RadioGroupItem = n15
const n16 = t([[22, 28],[23, 28],[24, 27],[25, 27],[26, 28],[27, 28],[29, 27],[28, 27]])

export const dark_surface4 = n16
const n17 = t([[30, 52],[31, 51],[32, 52],[33, 51]])

export const light_accent_alt1 = n17
const n18 = t([[30, 51],[31, 50],[32, 51],[33, 50]])

export const light_accent_alt2 = n18
const n19 = t([[22, 46],[23, 45],[24, 47],[25, 47],[26, 49],[27, 48],[29, 49],[28, 1]])

export const light_accent_active = n19
export const light_accent_surface3 = n19
export const light_accent_Button = n19
export const light_accent_SliderTrackActive = n19
const n20 = t([[22, 44],[23, 33],[24, 45],[25, 45],[26, 47],[27, 46],[29, 47],[28, 48]])

export const light_accent_surface1 = n20
export const light_accent_ListItem = n20
export const light_accent_SelectTrigger = n20
export const light_accent_Card = n20
export const light_accent_Progress = n20
export const light_accent_TooltipArrow = n20
export const light_accent_SliderTrack = n20
export const light_accent_Input = n20
export const light_accent_TextArea = n20
const n21 = t([[22, 45],[23, 44],[24, 46],[25, 46],[26, 48],[27, 47],[29, 48],[28, 49]])

export const light_accent_surface2 = n21
export const light_accent_Checkbox = n21
export const light_accent_Switch = n21
export const light_accent_TooltipContent = n21
export const light_accent_RadioGroupItem = n21
const n22 = t([[22, 48],[23, 48],[24, 49],[25, 49],[26, 48],[27, 48],[29, 49],[28, 49]])

export const light_accent_surface4 = n22
const n23 = t([[30, 65],[31, 45],[32, 65],[33, 45]])

export const dark_accent_alt1 = n23
const n24 = t([[30, 45],[31, 46],[32, 45],[33, 46]])

export const dark_accent_alt2 = n24
const n25 = t([[22, 50],[23, 1],[24, 64],[25, 64],[26, 48],[27, 47],[29, 48],[28, 49]])

export const dark_accent_active = n25
export const dark_accent_surface3 = n25
export const dark_accent_Button = n25
export const dark_accent_SliderTrackActive = n25
const n26 = t([[22, 52],[23, 64],[24, 53],[25, 53],[26, 1],[27, 49],[29, 1],[28, 50]])

export const dark_accent_surface1 = n26
export const dark_accent_ListItem = n26
export const dark_accent_SelectTrigger = n26
export const dark_accent_Card = n26
export const dark_accent_Progress = n26
export const dark_accent_TooltipArrow = n26
export const dark_accent_SliderTrack = n26
export const dark_accent_Input = n26
export const dark_accent_TextArea = n26
const n27 = t([[22, 64],[23, 50],[24, 52],[25, 52],[26, 49],[27, 48],[29, 49],[28, 1]])

export const dark_accent_surface2 = n27
export const dark_accent_Checkbox = n27
export const dark_accent_Switch = n27
export const dark_accent_TooltipContent = n27
export const dark_accent_RadioGroupItem = n27
const n28 = t([[22, 49],[23, 49],[24, 1],[25, 1],[26, 49],[27, 49],[29, 1],[28, 1]])

export const dark_accent_surface4 = n28
const n29 = t([[30, 7],[31, 6],[32, 8],[33, 8],[22, 17],[23, 16],[24, 17],[25, 16],[26, 15],[27, 14],[29, 13],[28, 12]])

export const light_SwitchThumb = n29
export const light_SliderThumb = n29
export const light_Tooltip = n29
export const light_ProgressIndicator = n29
const n30 = t([[22, 67]])

export const light_SheetOverlay = n30
export const light_DialogOverlay = n30
export const light_ModalOverlay = n30
export const light_accent_SheetOverlay = n30
export const light_accent_DialogOverlay = n30
export const light_accent_ModalOverlay = n30
const n31 = t([[30, 24],[31, 25],[32, 17],[33, 17],[22, 33],[23, 32],[24, 33],[25, 32],[26, 31],[27, 9],[29, 30],[28, 29]])

export const dark_SwitchThumb = n31
export const dark_SliderThumb = n31
export const dark_Tooltip = n31
export const dark_ProgressIndicator = n31
const n32 = t([[22, 68]])

export const dark_SheetOverlay = n32
export const dark_DialogOverlay = n32
export const dark_ModalOverlay = n32
export const dark_accent_SheetOverlay = n32
export const dark_accent_DialogOverlay = n32
export const dark_accent_ModalOverlay = n32
const n33 = t([[30, 44],[31, 33],[32, 45],[33, 45],[22, 53],[23, 52],[24, 53],[25, 52],[26, 51],[27, 50],[29, 1],[28, 49]])

export const light_accent_SwitchThumb = n33
export const light_accent_SliderThumb = n33
export const light_accent_Tooltip = n33
export const light_accent_ProgressIndicator = n33
const n34 = t([[30, 52],[31, 64],[32, 53],[33, 53],[22, 33],[23, 65],[24, 33],[25, 65],[26, 45],[27, 46],[29, 47],[28, 48]])

export const dark_accent_SwitchThumb = n34
export const dark_accent_SliderThumb = n34
export const dark_accent_Tooltip = n34
export const dark_accent_ProgressIndicator = n34